import { render, staticRenderFns } from "./ProjectTrialsListItem.vue?vue&type=template&id=fc007d38&scoped=true&"
import script from "./ProjectTrialsListItem.vue?vue&type=script&lang=js&"
export * from "./ProjectTrialsListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTrialsListItem.vue?vue&type=style&index=0&id=fc007d38&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc007d38",
  null
  
)

export default component.exports